import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaMapMarkerAlt,
  FaBirthdayCake,
  FaRulerVertical,
  FaBriefcase
} from "react-icons/fa";
import "animate.css";
import { baseUrl } from "../App";

function AdViewUsers() {

  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  // 🔎 Filter states
  const [gender, setGender] = useState("");
  const [city, setCity] = useState("");
  const [minAge, setMinAge] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  // 🔹 Fetch Active Users
  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${baseUrl}/active`);
      setUsers(res.data);
      setFilteredUsers(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔥 Apply Filters
  const applyFilters = () => {
    let result = users;

    if (gender) {
      result = result.filter(
        (u) => u.gender?.toLowerCase() === gender.toLowerCase()
      );
    }

    if (city) {
      result = result.filter(
        (u) => u.city?.toLowerCase() === city.toLowerCase()
      );
    }

    if (minAge) {
      result = result.filter(
        (u) => u.age >= parseInt(minAge)
      );
    }

    setFilteredUsers(result);
  };

  // 🔄 Reset Filters
  const resetFilters = () => {
    setGender("");
    setCity("");
    setMinAge("");
    setFilteredUsers(users);
  };

  // Get unique cities
  const uniqueCities = [...new Set(users.map(u => u.city).filter(Boolean))].sort();

  return (
    <div className="container mt-4">

      <h3 className="mb-4 text-center fw-bold">View Users 💍</h3>

      {/* ================= FILTER SECTION ================= */}
      <div className="card shadow-sm p-3 mb-4">
        <div className="row">

          <div className="col-md-3 mb-2">
            <select
              className="form-select"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">Looking For</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          <div className="col-md-3 mb-2">
            <select
              className="form-select"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            >
              <option value="">Select City</option>
              {uniqueCities.map((cityName) => (
                <option key={cityName} value={cityName}>
                  {cityName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mb-2">
            <input
              type="number"
              placeholder="Min Age"
              className="form-control"
              value={minAge}
              onChange={(e) => setMinAge(e.target.value)}
            />
          </div>

          <div className="col-md-2 mb-2">
            <button
              className="btn btn-primary w-100"
              onClick={applyFilters}
            >
              Search
            </button>
          </div>

          <div className="col-md-1 mb-2">
            <button
              className="btn btn-secondary w-100"
              onClick={resetFilters}
              title="Reset"
            >
              ↻
            </button>
          </div>

        </div>
      </div>

      {/* ================= USER CARDS ================= */}

      <div className="row">

        {filteredUsers.length === 0 && (
          <p className="text-center text-muted">
            No profiles found.
          </p>
        )}

        {filteredUsers.map((user) => (
          <div key={user.id} className="col-md-6 col-lg-4 mb-4">

            <div className="card shadow-sm border-0 h-100 animate__animated animate__fadeInUp">

              <div className="text-center mt-3">
                <img
                  src={`https://lingayatwelfarekarnataka.com/${user.profile_photo_path}`}
                  alt="Profile"
                  className="rounded-circle shadow"
                  style={{
                    width: "130px",
                    height: "130px",
                    objectFit: "cover",
                    border: "3px solid #0d6efd"
                  }}
                />
              </div>

              <div className="card-body text-center">

                <h5 className="fw-bold">{user.name}</h5>

                <p className="text-muted">
                  {user.age} Years • {user.gender}
                </p>

                <div className="text-start mt-3">

                  <p className="mb-1">
                    <FaMapMarkerAlt className="me-2 text-danger" />
                    {user.city}
                  </p>

                  <p className="mb-1">
                    <FaBirthdayCake className="me-2 text-warning" />
                    {user.date_of_birth}
                  </p>

                  <p className="mb-1">
                    <FaRulerVertical className="me-2 text-info" />
                    {user.height} cm
                  </p>

                  <p className="mb-1">
                    <FaBriefcase className="me-2 text-success" />
                    {user.annual_income}
                  </p>

                </div>

              </div>

            </div>

          </div>
        ))}

      </div>

    </div>
  );
}

export default AdViewUsers;